import { render, staticRenderFns } from "./ForumPoll.vue?vue&type=template&id=23ff3e0a&"
import script from "./ForumPoll.vue?vue&type=script&lang=js&"
export * from "./ForumPoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports